module.exports = __webpack_public_path__ + "img/passalacqua_0.1dd456ea.jpg";